module.exports = __webpack_public_path__ + "img/awards1.184fa61f.svg";